

  ///////////////////////////////////////////////////////////////////////////
  //Browser Version 1.0
  ///////////////////////////////////////////////////////////////////////////
  //
  //
  //  put on 'body' to add classes per browser , or just copy and paste below to initiate
  /////////////////////////////////////////////////////////
  //                                                     //
  //  $('body').browserVersion();                        //
  //                                                     //
  /////////////////////////////////////////////////////////
  //
  //

    //Detect browser and add class
    (function detectIE() {
      var ua = window.navigator.userAgent;

      var msie = ua.indexOf('MSIE ');
      if (msie > 0) {
        // IE 10 or older => return version number
        document.querySelector('body').className += ' ie11';
      }

      var trident = ua.indexOf('Trident/');
      if (trident > 0) {
        // IE 11 => return version number
        document.querySelector('body').className += ' ie11';
      }

      var edge = ua.indexOf('Edge/');
      if (edge > 0) {
        // IE 12 (aka Edge) => return version number
        document.querySelector('body').className += ' ieEdge';
      }

      // other browser
      return false;
    })();



  ///////////////////////////////////////////////////////////////////////////
  //add classes to body per browser end
  ///////////////////////////////////////////////////////////////////////////



